/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_No_Streams_AvailableInputs */

const en_audio_embed_export_no_streams_available = /** @type {(inputs: Audio_Embed_Export_No_Streams_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No audio streams were detected in either input. Add an audio source to enable export.`)
};

const fr_audio_embed_export_no_streams_available = /** @type {(inputs: Audio_Embed_Export_No_Streams_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun flux audio n'a été détecté dans les deux entrées. Ajoutez une source audio pour activer l'exportation.`)
};

const de_audio_embed_export_no_streams_available = /** @type {(inputs: Audio_Embed_Export_No_Streams_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine Audiostreams in den Eingängen erkannt. Fügen Sie eine Audioquelle hinzu, um den Export zu aktivieren.`)
};

const it_audio_embed_export_no_streams_available = /** @type {(inputs: Audio_Embed_Export_No_Streams_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato rilevato alcun flusso audio in nessuno dei due ingressi. Aggiungi una sorgente audio per abilitare l'esportazione.`)
};

const ru_audio_embed_export_no_streams_available = /** @type {(inputs: Audio_Embed_Export_No_Streams_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиопотоки не обнаружены ни в одном из входов. Добавьте источник звука, чтобы включить экспорт.`)
};

const es_audio_embed_export_no_streams_available = /** @type {(inputs: Audio_Embed_Export_No_Streams_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se detectaron flujos de audio en ninguna de las entradas. Añada una fuente de audio para habilitar la exportación.`)
};

const zh_cn2_audio_embed_export_no_streams_available = /** @type {(inputs: Audio_Embed_Export_No_Streams_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两个输入源均未检测到音频流。请添加音频源以启用导出功能。`)
};

const ja_audio_embed_export_no_streams_available = /** @type {(inputs: Audio_Embed_Export_No_Streams_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どちらの入力でも音声ストリームが検出されませんでした。エクスポートを有効にするには、音声ソースを追加してください。`)
};

const hi_audio_embed_export_no_streams_available = /** @type {(inputs: Audio_Embed_Export_No_Streams_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दोनों इनपुट में कोई ऑडियो स्ट्रीम नहीं मिली। निर्यात सक्षम करने के लिए एक ऑडियो स्रोत जोड़ें।`)
};

const pt_pt2_audio_embed_export_no_streams_available = /** @type {(inputs: Audio_Embed_Export_No_Streams_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma fonte de áudio foi detectada em nenhuma das entradas. Adicione uma fonte de áudio para habilitar a exportação.`)
};

/**
* | output |
* | --- |
* | "No audio streams were detected in either input. Add an audio source to enable export." |
*
* @param {Audio_Embed_Export_No_Streams_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_no_streams_available = /** @type {((inputs?: Audio_Embed_Export_No_Streams_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_No_Streams_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_no_streams_available(inputs)
	if (locale === "de") return de_audio_embed_export_no_streams_available(inputs)
	if (locale === "it") return it_audio_embed_export_no_streams_available(inputs)
	if (locale === "ru") return ru_audio_embed_export_no_streams_available(inputs)
	if (locale === "es") return es_audio_embed_export_no_streams_available(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_no_streams_available(inputs)
	if (locale === "ja") return ja_audio_embed_export_no_streams_available(inputs)
	if (locale === "hi") return hi_audio_embed_export_no_streams_available(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_no_streams_available(inputs)
	return en_audio_embed_export_no_streams_available(inputs)
});